/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/merklist-action-info.ts.
 */
import {GuiMessage} from './gui-message';

/**
 * Zweck: Beschreibt class MerklistActionInfo und ihren Daten- oder Funktionsvertrag.
 */
export class MerklistActionInfo {
  action: string;
  info: GuiMessage;
}
